const rotateElement = document.querySelector('.rotate-element');

window.addEventListener('scroll', () => {
    // ページのスクロール量を取得
    const scrollPosition = window.scrollY;

    // スクロール量に応じた回転角度を計算（例としてスクロール1pxにつき0.1度回転）
    const rotation = scrollPosition * 0.075;

    // 要素を回転させる
    rotateElement.style.transform = `rotate(${rotation}deg)`;
});